import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { AppContext } from "../../AppContext";

import Modal from "../../components/Modal";

import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
export default function Project() {
    const { data } = useContext(AppContext);
    const [open, setOpen] = useState(false);
    const [detailNav, setdetailNav] = useState(false);

    const { projectId, subId } = useParams();
    var slider = null;
    const handleOpen = () => {
        // 模拟数据传入
        setOpen(true);
    };
    function HtmlText({ html }) {
    return <span dangerouslySetInnerHTML={{ __html: html }} />;
    }

    const settings = {
        dots: true,
        // dots: {'dot-style':String},
        infinite: true,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    return (
        <div className="page page1111" id="pProjectDetail">
            <img src={`/image/${parseInt(projectId)}.png`} className="pageTitle" />
            <div className="pContent">
                <div className="blockTit">{data?.project[projectId][subId].title}</div>
                <div className={data?.project[projectId][subId].hideDetail ? "detailTop detailTop-hide" : "detailTop"} >
                    <div className="pd-img">
                        {
                            data?.project[projectId][subId].hideDetail ? 

                        <img src={data?.project[projectId][subId].cover1} alt="" />:

                        <img src={data?.project[projectId][subId].cover} alt="" />

                        }
                    </div>
                    <div >
                        <p className="blockText" >
                            <HtmlText html={data?.project[projectId][subId].detail} />
                            
                            {data?.project[projectId][subId].detailImg ?
                                <i data-v-c079c198="" class="mIcon mu-icon  material-icons  " onClick={handleOpen}>info_outline</i>
                                :
                                <></>
                            }
                        </p>
                        <ul className="pdInfo">
                            <li >
                                <div >项目时间</div>
                                <div className="con">{data?.project[projectId][subId].time} 分钟</div>
                            </li>
                            <li >
                                <div >项目价格</div>
                                <div className="con">
                                    <span >¥{data?.project[projectId][subId].price}（新人价 ¥{data?.project[projectId][subId].pricenew}）</span>
                                    <div className="showListBtn" onClick={() => { setdetailNav(!detailNav) }}>
                                        <span >会员价格</span>
                                        <span className={detailNav ? "icon active" : "icon"}>∨</span>
                                    </div>
                                </div>
                            </li>
                            <li style={{ display: detailNav ? "" : "none" }}>
                                <div ></div>
                                <div className="con">
                                    <span className="priceIcon level1"></span>
                                    <span className="priceName">普通会员</span>
                                    <span >¥{data?.project[projectId][subId].price1}</span>
                                </div>
                            </li>
                            <li style={{ display: detailNav ? "" : "none" }}>
                                <div ></div>
                                <div className="con">
                                    <span className="priceIcon level2"></span>
                                    <span className="priceName">金卡会员</span>
                                    <span >¥{data?.project[projectId][subId].price2}</span>
                                </div>
                            </li>
                            <li style={{ display: detailNav ? "" : "none" }}>
                                <div ></div>
                                <div className="con">
                                    <span className="priceIcon level3"></span>
                                    <span className="priceName">黑卡会员</span>
                                    <span >¥{data?.project[projectId][subId].price3}</span>
                                </div>
                            </li>
                            <li >
                                <div >项目部位</div>
                                <div className="con">{data?.project[projectId][subId].body}</div>
                            </li>
                            <li >
                                <div >项目亮点</div>
                                <div className="con">{data?.project[projectId][subId].easy}</div>
                            </li>
                        </ul>
                    </div>
                </div>

                {data?.project[projectId][subId].swiper?.length > 0 ?
                    <Slider {...settings}
                        ref={c => (slider = c)}>
                        {
                            data?.project[projectId][subId].swiper.map((val, index) =>
                                <div className='planediv' key={index} >
                                    <img src={val} className='plane' />
                                </div>
                            )
                        }
                    </Slider>
                    : <div></div>

                }
                {data?.project[projectId][subId].detail1.map((val, index) => 
                    val.ismore ?
                        <div>
                            <div className="step clearfix stepmore " key={index}>
                                <p className={"blockTit " + (val.ptitle ? "ptitle" : "")}>
                                    {val.ptitle ?
                                        <span className="text">{val.ptitle}</span>
                                        :
                                        <span >POINT {index + 1}</span>

                                    }
                                </p>
                                <p className="blockText">{val.title}</p>

                            </div>
                            <div className="step clearfix  stepmore1 ">
                                <img src={val.cover} alt="" />
                            </div>
                        </div>
                        :
                        <div className="step clearfix  " key={index}>
                            <p className={"blockTit " + (val.ptitle ? "ptitle" : "")}>
                                {val.ptitle ?
                                    <span className="text">{val.ptitle}</span>
                                    :
                                    <span >POINT {index + 1}</span>

                                }
                            </p>
                            <p className="blockText">{val.title}</p>
                            <img src={val.cover} alt="" />
                        </div>
                )}
                
                {data?.project[projectId][subId].detail2
                    ?
                    data.project[projectId][subId].detail2.map((val, index) =>
                        <div className="step2 " key={index}>
                            <span className="text">{val}</span>
                        </div>

                    )
                    : <div></div>}
                {data?.project[projectId][subId].detail3
                    ?
                    data.project[projectId][subId].detail3.map((val, index) =>
                        <div className="step3 " key={index}>
                            <span className="title">{val.ptitle}</span>
                            <span className="text">{val.title}</span>
                        </div>
                    )
                    : <div></div>}



                <Modal open={open} onClose={() => setOpen(false)}>
                    <img src={data?.project[projectId][subId].detailImg} alt="" />
                </Modal>


            </div>
        </div>
    );
}